<template>
  <div
    v-if="visible"
    class="position-absolute d-flex flex-column align-items-center justify-content-center loading-overlay"
  >
    <b-spinner :variant="variant" style="width: 3rem; height: 3rem;" />
    <p class="mt-2 mb-0 font-weight-bold" :class="`text-${variant}`">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "Loading...",
    },
    variant: {
      type: String,
      default: "primary",
    },
  },
};
</script>

<style scoped>
.loading-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 1000;
}
</style>
